import { createContext } from '@berlin-front/common/composables/context';
import { UnwrapRef } from '@vue/composition-api';

export type AuthMemberConfirmType = {
  useMemberConfirm: () => UnwrapRef<{
    member: {
      name: string;
      kana: string;
      sex: string;
      birthday: string;
      zip: string;
      address1: string;
      address2: string;
      phoneNumber: string;
    };
    messages: string[];
    progress: number;

    sendSmsCode: () => void;
    editMemberInfo: () => void;
  }>;
};

export const AuthMemberConfirmContext = createContext<AuthMemberConfirmType>({} as AuthMemberConfirmType);
